import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {PlayerContainer} from '../../player/player.container';
import {fromEvent, Observable, of, takeUntil} from 'rxjs';
import {catchError, delay, finalize, repeat, switchMap, take, tap} from 'rxjs/operators';
import {CachingService} from "../../services/caching/caching.service";
import {PlayerBase} from "../../player/player.base";
import {MusicListComponent} from "../music-list/music-list.component";

@Component({
  selector: 'app-music',
  template: `<div #component></div>`,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MusicComponent extends PlayerBase {
    audio;

    constructor(protected injector: Injector) {
        super(injector);
        this.audio = new Audio();
    }

    load(playerObject: any): Observable<any> {
        let self;
        return super.load(playerObject).pipe(
            switchMap(playerBase => {
                self = playerBase;
                if (this.editMode) {
                    this.showMsg("Music", "");
                    return of('a');
                } else {
                    const resourceId = this.data.Resource[0].$.resource;
                    return (<CachingService>this.playerService.caching).getResource(resourceId).pipe(
                        switchMap(path => {
                            this.audio.src = String(path);
                            this.audio.load(); // Reload the audio
                            this.audio.play(); // Play the new audio
                            if (!(self.parentPlayer instanceof MusicListComponent)) {
                                this.audio.loop = true;
                            }
                            return fromEvent(this.audio, 'ended').pipe(
                                take(1)
                            )
                        })
                    )
                }
            }),
            catchError(err => this.logError(err)),
            switchMap(a => of(self)),
            takeUntil(this.finish$),
            finalize( () => {
                if (this.audio) {
                    this.audio.pause();
                    this.audio.src = ''; // Remove source
                    this.audio.load(); // Reset audio
                    this.audio.onended = null; // Remove event listener
                    this.audio = null; // Allow garbage collection
                }
            })

        )
    }
}
